import React from 'react'
import { connect } from 'react-redux'
import ImageEditModal from '../../components/templates/image-edit/ImageEditModal'
import { changePortal } from '../../actions/portal'

class ImageUploadEditModal extends React.Component {
  handleUpload = async ({ ref, currentImageId, onClose }) => {
    if (currentImageId) {
      this.props.onReloadImage()
    } else {
      this.props.changePortal('mainImageId', ref)
      this.props.onReloadImage()
    }
    onClose()
  }

  render() {
    return <ImageEditModal {...this.props} handleUpload={this.handleUpload} />
  }
}

export default connect(null, { changePortal })(ImageUploadEditModal)



// WEBPACK FOOTER //
// ./src/modules/image/ImageUploadEditModal.js